export default "__VITE_ASSET__gb08kU4x__"